/**
 * 分を指定した時間単位に切り捨てる
 * @param minutes - 分（0-59）
 * @param timeUnit - 時間単位（例: 5分刻みなら5）
 * @returns 切り捨てた分（例: 58分を5分刻みで切り捨てると55）
 */
export const floorToTimeUnit = (minutes: number, timeUnit: number): number => {
  return Math.floor(minutes / timeUnit) * timeUnit;
};

/**
 * 時刻（時・分）を分に変換する
 * @param hour - 時（0-23）
 * @param minute - 分（0-59）、未指定の場合は0
 * @returns 総分数（例: 12時30分 → 750）
 */
export const timeToMinutes = (hour: number, minute?: number): number => {
  return hour * 60 + (minute ?? 0);
};

/**
 * 時刻文字列（時・分）を分に変換する
 * @param hourStr - 時の文字列（例: "12"）、空文字の場合はnullを返す
 * @param minuteStr - 分の文字列（例: "30"）、空文字の場合は0として扱う
 * @returns 総分数、hourStrが空の場合はnull
 */
export const parseTimeToMinutes = (
  hourStr: string,
  minuteStr?: string,
): number | null => {
  if (!hourStr) return null;
  const hour = parseInt(hourStr, 10);
  const minute = minuteStr ? parseInt(minuteStr, 10) : 0;
  return timeToMinutes(hour, minute);
};
